/*
 * Copyright Elasticsearch B.V. and/or licensed to Elasticsearch B.V. under one
 * or more contributor license agreements. Licensed under the Elastic License
 * 2.0; you may not use this file except in compliance with the Elastic License
 * 2.0.
 */

// DO NOT MODIFY THIS FILE BY HAND. IT IS GENERATED BY
// `yarn workspace @elastic/esql-definitions generate` FROM
// `elasticsearch/esql/x-pack-esql/definition/functions/range_max.json`.

import type { FunctionDefinition } from '../../definition_types';

/**
 * Returns the maximum (end) value of a range. For a range [x, y), it returns y.
 *
 * @example
 * FROM decades
 * | WHERE decade == 1900
 * | EVAL max_bound = RANGE_MAX(date_range)
 * | KEEP date_range, max_bound
 */
const definition: FunctionDefinition = {
  type: 'scalar',
  name: 'range_max',
  signatures: [
    {
      params: [
        {
          name: 'range',
          type: 'date_range',
          optional: false,
        },
      ],
      variadic: false,
      returnType: 'date',
    },
    {
      params: [
        {
          name: 'range',
          type: 'double_range',
          optional: false,
        },
      ],
      variadic: false,
      returnType: 'double',
    },
  ],
  preview: true,
  snapshotOnly: false,
};

export default definition;
